import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Ticker from "@/components/landing/Ticker";
import CleanFunds from "@/components/landing/CleanFunds";
import Guarantee from "@/components/landing/Guarantee";
import HowItWorks from "@/components/landing/HowItWorks";
import RateSection from "@/components/landing/RateSection";
import WhyRupora from "@/components/landing/WhyRupora";
import AppPreview from "@/components/landing/AppPreview";
import Faq from "@/components/landing/Faq";
import CTASection from "@/components/landing/CTASection";
import Footer from "@/components/landing/Footer";
import StickyCTA from "@/components/landing/StickyCTA";
import { Toaster } from "@/components/ui/sonner";
import LegalPage from "@/pages/LegalPage";
import LoginPage from "@/pages/LoginPage";
import { LEGAL_PAGES } from "@/content/legal";

function Landing() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (e) => {
      const anchor = e.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id && id.length > 1) {
        const el = document.querySelector(id);
        if (el) {
          e.preventDefault();
          lenis.scrollTo(el, { offset: -72 });
        }
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <div className="grain min-h-screen bg-night font-sans text-paper antialiased overflow-x-clip" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <Ticker />
        <CleanFunds />
        <Guarantee />
        <HowItWorks />
        <RateSection />
        <WhyRupora />
        <AppPreview />
        <Faq />
        <CTASection />
      </main>
      <Footer />
      <StickyCTA />
      <Toaster position="bottom-center" richColors />
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<LoginPage />} />
        {Object.values(LEGAL_PAGES).map((p) => (
          <Route key={p.path} path={p.path} element={<LegalPage page={p} />} />
        ))}
        <Route path="*" element={<Landing />} />
      </Routes>
    </BrowserRouter>
  );
}
